import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as viewReducer from "containers/View/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as tasksReducer from "containers/Tasks/TasksReducer";
import * as reportReducer from "containers/Report/ReportReducer";

import SubView from "components/View/SubView";

import TasksTile from "components/Tiles/TasksTile";

class TasksViewContainer extends React.Component {
  getHeaders() {
    return ["Project", "Creation", "Contributors", "Subgroups", "Created By"];
  }

  render() {
    const { data, deleteReport, deleteTask, openExploreTask, updateClickedTask, userId, history } = this.props;

    const orderedData = data.sort((a, b) => parseFloat(b.id) - parseFloat(a.id));

    return (
      <React.Fragment>
        <SubView
          {...this.props}
          label="Exploration"
          headers={this.getHeaders()}
          firstTile={<div />}
          firstRow={<div />}
          length={data.length}
          isInfinite={true}
          hideShowMore={true}
          renderTile={(columnIndex, style) => {
            return data && data.length > columnIndex ? (
              <div style={style} key={columnIndex}>
                <TasksTile
                  onClick={() => {
                    const task = orderedData[columnIndex];
                    console.log("clicked task ", task);

                    if (task?.nextId !== undefined) {
                      history.push("exploreTask/" + orderedData[columnIndex]?.id);
                    } else {
                      history.push("task/" + orderedData[columnIndex]?.id);
                    }
                  }}
                  handleDelete={() => deleteTask(orderedData[columnIndex]?.id)}
                  data={orderedData[columnIndex]}
                  userId={userId}
                />
              </div>
            ) : undefined;
          }}
          childrenLength={data.length}
          emptyMessage={
            <div
              style={{
                height: "200px",
                minWidth: "200px",
                marginLeft: "10px",
                display: "flex",
                alignItems: "center",
                fontSize: "20px",
                color: "#777"
              }}
            >
              {"No tasks have been assigned"}
            </div>
          }
        ></SubView>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  openExploreTask: (task) => dispatch(tasksReducer.openExploreTask(task)),
  updateClickedTask: (task) => dispatch(tasksReducer.updateClickedTask(task)),
  deleteTask: (taskId) => dispatch(projectReducer.deleteTask(taskId))
});

const mapStateToProps = (state, ownProps) => {
  return {
    data: viewReducer.getTasks(state),
    type: viewReducer.getType(state),
    isTile: viewReducer.getIsTile(state),
    userId: loginReducer.getUserID(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(TasksViewContainer);
